import MapContain from './MapContain';

export default MapContain;
